'use client';

import Link from 'next/link';
import parse from 'html-react-parser';
import { useSettings } from '@/hooks/useSettings';

interface SettingItem {
  type: string;
  value: string | null;
}

export default function AboutPage() {
  const { generalSettings } = useSettings();

  // Function to clean HTML by removing Office-specific tags
  const renderCleanHtml = () => {
    const aboutData = generalSettings?.find((item: SettingItem) => item.type === 'about_us');
    if (!aboutData?.value) return null;

    // Remove Office-specific tags like <o:p> and </o:p>
    const cleanHtml = aboutData?.value.replace(/<\/?o:[a-z]+>/gi, '');
    return parse(cleanHtml);
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <div className="about-section">
        <div className="container">{renderCleanHtml()}</div>
      </div>
    </>
  );
}
